import React from 'react';
import ReactDOM from 'react-dom';
import InformationalPageContent from "./InformationalPageContent";

var salonCountries = JSON.parse(document.getElementById("salonCountries").textContent); // eslint-disable-next-line

if (document.getElementById("breadcrumbJson") !== null) {
    var breadcrumbs = JSON.parse(document.getElementById("breadcrumbJson").textContent); // eslint-disable-next-line
}

if (document.getElementById("instagram")) {
    var instagram = JSON.parse(document.getElementById("instagram").textContent); // eslint-disable-next-line
}

if (document.getElementById("articleJson") && document.getElementById("ArticlePage")) {
    var aboutHairLoss = JSON.parse(document.getElementById("articleJson").textContent); // eslint-disable-next-line
    var language = document.getElementById('divlang').getAttribute('data-id'); // eslint-disable-next-line
    ReactDOM.render(<InformationalPageContent lang={language} salonCountries={salonCountries} Model={aboutHairLoss} breadcrumbs={breadcrumbs} />, document.getElementById('ArticlePage'));
}
